// Vendor Libs
import React from 'react';
import {Provider, useSelector} from 'react-redux';

// Dish Tech React
import {useRouter} from '@dishtech-react/hooks';
import {AuthLoading, Unauthorized} from '@dishtech-react/core';

// Contexts
import {RouteContext} from '../contexts/route-context';
import logo from '../assets/dish_red.svg';
import Raindrop from './Raindrop';

import appStore from '../redux/app-store';

const AuthLayout = () => {
  const userData = useSelector((state) => state?.auth?.user);

  return (
    <div className="main">
      <RouteContext.Provider value={useRouter()}>
        {!userData?.credentialsNonExpired ? (
          <AuthLoading img={logo} />
        ) : userData?.isAuthorized ? (
          <div className="main--content">
            <Provider store={appStore}>
              <Raindrop inputEmail={userData?.email} inputName={userData?.name} />
            </Provider>
          </div>
        ) : (
          <Unauthorized />
        )}
      </RouteContext.Provider>
    </div>
  );
};

export default AuthLayout;
